import { z } from 'zod'
import interceptedAxios from '../../../utils/interceptedAxios'

const ZCreateSiteApiResponse = z.object({
  id: z.string(),
  siteName: z.string(),
  description: z.string()
})

export interface CreateSitePostRequest {
  siteName: string
  description: string
}

const ZApiResponse = z.object({
  http_status: z.number(),
  data: ZCreateSiteApiResponse,
  error: z.boolean()
})

export type CreateSiteApiResponse = z.infer<typeof ZCreateSiteApiResponse>
export type ApiResponse = z.infer<typeof ZApiResponse>

export async function createSite (
  createSitePostRequest: CreateSitePostRequest,
  onSuccess: (successResponse: CreateSiteApiResponse, httpStatus: number) => any,
  onFailure: (errorMessage: string, httpStatus: number) => any
): Promise<void> {
  const url = '/assetrest/api/v2/udp/tiq/sites'
  interceptedAxios
    .post(url, createSitePostRequest, { timeout: 15000 })
    .then((response) => {
      const parseResponse = ZApiResponse.safeParse(response.data)
      // console.log('parseResponse', parseResponse)
      if (parseResponse.success) {
        onSuccess(parseResponse.data.data, parseResponse.data.http_status)
      } else {
        onFailure('Error occurred while processing response', response.status)
      }
    })
    .catch((error) => {
      if (error.response !== undefined) {
        if (error.response.data !== undefined) {
          onFailure(error.response.data.error_message, error.response.data.http_status)
        } else {
          onFailure(error.response.statusText, error.response.status)
        }
      } else {
        onFailure('Network Failure', error.status)
      }
    })
}
